
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useContext, useEffect, useMemo, useRef, useState } from "react";
import styles from "pages/events/[eid]/Bok.module.scss";
import classNames from "classnames";
import utilStyles from "styles/utils.module.scss";
import StoreNavBar from "components/layout/NavBar/StoreNavBar";
import { Col, Row } from "react-bootstrap";
import ProductListCard from "components/cards/ProductListCard";
import CategoryContext from "context/CategoryContext";
import { useRouter } from "next/router";
import { Axios } from "api";
import { productScrapContextRef } from "context/ProductScrapContext";
import LoadingDot from "components/LoadingDot";
import PurchaseButton from "components/buttons/PurchaseButton";
import { addOptionCountImpl, setOptionCountImpl } from "components/pages/ProductDetail";
import { deleteOptionCountImpl } from "pages/reservation/products/[pid]";
import OptionSelector from "components/input/OptionSelector";
import Modal from "components/Modal";
import OptionSelectionDropdownWithQuantitySelector from "components/dropdown/OptionSelectionDropdownWithQuantitySelector";
import FullButton from "components/buttons/FullButton";
import { captureException, captureMessage } from "@sentry/nextjs";
import BottomModal from "components/BottomModal";
import CloseIcon from "images/icons/close.svg";
import Image from "next/image";
import NewQuantitySelector from "components/buttons/NewQuantitySelector";
import { customConfirm, isApp, numberWithComma, showToast } from "common/utils";
import { toast } from "react-toastify";
import AlimIcon from "images/icons/notification.svg";
import ArrowRightIcon from "images/icons/arrow_right_757575_16.svg";
import Link from "next/link";
import { KEY_TYPE_GIFT } from "pages/events/index";
import { getEventApplyRoute, getProductRoute } from "common/const";
import useNotiSubscription from "hooks/useNotiSubscription";
import KakaoLoader from "components/KakaoLoader";
import * as Sentry from "@sentry/nextjs";
import Clipboard from "react-clipboard.js";
import { redirectToLogin as _redirectToLogin } from "common/redirect";
import UserContext from "context/AuthContext";
import BokEventResultModal from "components/modal/BokEventResultModal";
import { BokEventBeltBanner, BokEventReferralBeltBanner } from "components/banner/BeltBanner";
import ModalContext from "context/ModalContext";
import { PUSH_AGREEMENT_INFORMATION } from "context/PushContext";
const PouchModal = ({ pouchItems, addToPouch, setPouchItems, isLoading, close }) => {
    const [syncCountTrigger, setSyncCountTrigger] = useState(0);
    return (<div className={styles.pouchModalWrapper}>
            <div className={styles.pouchModalTitle}>내 복바구니</div>
            <div className={styles.pouchListContainer}>
                {pouchItems.map(item => {
            return (<div className={styles.pouchItemContainer} key={item.id}>
                                <div className={styles.pouchItemTitleWrapper}>
                                    <span className={styles.pouchItemTitle}>{item.option.brand_name}</span>
                                    <div className={styles.pouchCloseButton} onClick={() => {
                    addToPouch({ [item.option.id]: 0 });
                }}>
                                        <CloseIcon viewBox="0 0 20 20"/>
                                    </div>
                                </div>
                                <div className={styles.pouchItemContentContainer}>
                                    <div className={styles.pouchItemThumbnailWrapper}>
                                        <Image unoptimized layout={'fill'} objectFit={'cover'} src={item.option.product_thumbnail_urls[0]}/>
                                    </div>
                                    <div className={styles.pouchItemContentWrapper}>
                                        <div>
                                            <div className={styles.pouchItemProductName}>{item.option.product_name}</div>
                                            <span className={styles.pouchItemOptionName}>{item.option.name}</span>
                                        </div>
                                        <div className={styles.pouchItemBottomButtonContainer}>
                                            <div className={styles.pouchItemQuantitySelectorWrapper}>
                                                <NewQuantitySelector disabled={isLoading} dark={true} fontSize={14} count={item.count} onMinus={() => addToPouch({ [item.option.id]: item.count - 1 })} onPlus={() => addToPouch({ [item.option.id]: item.count + 1 })} setCount={(count) => addToPouch({ [item.option.id]: count })} syncCountTrigger={syncCountTrigger} newStyle/>
                                            </div>
                                            <div className={styles.priceContainer}>
                                                {item.option.discount_rate > 0 &&
                    <div className={styles.pouchItemPercentage}>{item.option.discount_rate}<span className={utilStyles.bold}>%</span></div>}
                                                <div className={styles.pouchItemPrice}>{numberWithComma(item.option.discounted_price * item.count)}</div>
                                                <div className={styles.pouchItemWon}>원</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>);
        })}
            </div>
            <div className={styles.totalContainer}>
                <div className={styles.totalPriceInfo}>
                    <div className={styles.totalPriceDesc}>
                        합계:
                    </div>
                    <div className={styles.totalPrice}>
                        {numberWithComma(pouchItems.reduce((acc, cur) => acc + cur.option.discounted_price * cur.count, 0))}
                        <span className={styles.totalPriceWon}>원</span>
                    </div>
                </div>
                <div className={styles.warning}>
                    복바구니는 최대 50,000원까지만 담을 수 있어요
                </div>
                <div className={styles.pouchModalFullButtonContainer}>
                    <FullButton onClick={() => {
            close();
        }} height={48} fontSize={16}>닫기</FullButton>
                </div>
            </div>
        </div>);
};
const SHARE_TARGET_URL = 'https://www.hemekolab.com/events/1918?hmkcid=20240207_bok_event_share&hideApp=true';
const Bok = ({ event, bokInfo }) => {
    const user = useContext(UserContext).user;
    const categoryContext = useContext(CategoryContext);
    const categories = useMemo(() => {
        return categoryContext.productCategories.filter(e => !e.parent_id && !!e.id).sort((a, b) => a.rank - b.rank);
    }, [categoryContext.productCategories]);
    const [isLoading, setIsLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [currentCategory, setCurrentCategory] = useState(null);
    useEffect(() => {
        setCurrentCategory({ id: null });
    }, [categories]);
    const fetchProducts = async (categoryId, size) => {
        try {
            setIsLoading(true);
            setProducts([]);
            const res = await Axios.get(`v1/events/${event.id}/products`, {
                params: {
                    category_id: categoryId,
                    size: size
                }
            });
            productScrapContextRef.current.updateByProductIdsAndScrappedProductIds(res.data.product_list.map(e => e.id), res.data.scrapped_pids);
            setProducts(res.data.product_list.map(e => {
                delete e.my_price_info;
                return e;
            }));
        }
        catch { }
        finally {
            setIsLoading(false);
        }
    };
    const { openAppInstallModal } = useContext(ModalContext);
    const redirectToLogin = () => {
        customConfirm('해당 이벤트는 회원만 참여할 수 있어요.\n로그인하시겠어요?', '확인', '취소', () => {
            _redirectToLogin(router, true);
        }, () => { });
    };
    const redirectToApp = () => {
        customConfirm('해당 이벤트는 앱에서만 참여할 수 있어요.\n앱을 설치하시겠어요?', '확인', '취소', () => {
            openAppInstallModal();
        }, () => { });
    };
    const addToPouch = async (optionIdToCount) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokAddToPouch', {
            isMember: !!user
        });
        if (!user) {
            redirectToLogin();
            return;
        }
        try {
            setIsPouchLoading(true);
            const res = await Axios.post(`v1/events/${event.id}/pouch-items/`, {
                checkout_item_list: Object.entries(optionIdToCount).map(([optionId, count]) => {
                    return {
                        option_id: optionId,
                        count: count
                    };
                })
            });
            if (res.status < 400) {
                if (Object.values(optionIdToCount).filter(e => e > 0).length > 0) {
                    toast.info('복바구니에 담았어요', { autoClose: 1000 });
                }
                setPouchItems(res.data.pouch_items);
                closeOptionSelector();
            }
            else if (res.status === 401) {
                redirectToLogin();
            }
            else {
                if (res.data.display_message) {
                    toast.info(res.data.display_message);
                }
                else {
                    captureMessage(res.data.message);
                }
            }
        }
        catch (e) {
            captureException(e);
        }
        finally {
            setIsPouchLoading(false);
        }
    };
    const fetchPouchItems = async () => {
        try {
            setIsPouchLoading(true);
            const res = await Axios.get(`v1/events/${event.id}/pouch-items/`);
            if (res.status < 400) {
                setPouchItems(res.data.pouch_items);
            }
        }
        catch (e) {
            captureException(e);
        }
        finally {
            setIsPouchLoading(false);
        }
    };
    const [chartProducts, setChartProducts] = useState([]);
    const fetchProductChart = async () => {
        try {
            const res = await Axios.get(`v1/events/${event.id}/products`, {
                params: {
                    category_id: null,
                    size: 3,
                    order_by_pouch_count: true
                }
            });
            productScrapContextRef.current.updateByProductIdsAndScrappedProductIds(res.data.product_list.map(e => e.id), res.data.scrapped_pids);
            setChartProducts(res.data.product_list.map(e => {
                delete e.my_price_info;
                return e;
            }));
        }
        catch { }
    };
    useEffect(() => {
        fetchPouchItems();
        fetchProductChart();
    }, []);
    useEffect(() => {
        if (!currentCategory) {
            return;
        }
        fetchProducts(currentCategory.id, null);
    }, [currentCategory]);
    const tabRef = useRef(null);
    const [targetProduct, setTargetProduct] = useState(null);
    const onPouchClick = (product) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokProductListCardPouchButtonClick', {
            productId: product.id
        });
        setTargetProduct(product);
    };
    const [selectedOptions, setSelectedOptions] = useState({});
    const [isPouchLoading, setIsPouchLoading] = useState(false);
    const [isPouchModalOpen, setIsPouchModalOpen] = useState(false);
    const [pouchItems, setPouchItems] = useState([]);
    const specialProduct = event && event.products && event.products[0] ? event.products[0] : null;
    const router = useRouter();
    const [referralCode, setReferralCode] = useState(null);
    useEffect(() => {
        const referral = router.query.referral;
        if (typeof window !== 'undefined' && referral) {
            setReferralCode(referral);
            window.sessionStorage.setItem(`bok_event_referral`, referral);
        }
    }, [router.query.referral]);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const referral = window.sessionStorage.getItem(`bok_event_referral`);
            if (referral) {
                const urlReferral = new URLSearchParams(window.location.search).get('referral');
                if (urlReferral && referral !== urlReferral) {
                    return;
                }
                setReferralCode(referral);
            }
        }
    }, []);
    const participationDisabled = event?.max_participation_count <= event?.participation_count;
    const onParticipateClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('ParticipationClick', {
            isMember: !!user
        });
        if (!isApp()) {
            redirectToApp();
            return;
        }
        if (!user) {
            redirectToLogin();
            return;
        }
        if (!pouchItems || pouchItems.length === 0) {
            toast.info('복바구니에 제품을 담고 응모해보세요!');
            return;
        }
        const link = getEventApplyRoute(event.id);
        router.push(link);
    };
    const closeOptionSelector = () => {
        setSelectedOptions({});
        setTargetProduct(null);
    };
    const handleSubscribe = () => {
        toast.info('이벤트 알림을 설정했어요.', {
            autoClose: 1000
        });
    };
    const handleUnsubscribe = () => {
        toast.info("이벤트 알림을 해제했어요.", {
            autoClose: 1000
        });
    };
    const EVENT_NOTI_TOPIC_KEY = 'custom_topic@bok_pouch_event';
    const { notiTypeAndKeyToIsSubscribedAndPushOn, toggleSubscription, overrideIsSubscribed } = useNotiSubscription({ [EVENT_NOTI_TOPIC_KEY]: false }, handleSubscribe, handleUnsubscribe, "복바구니 이벤트");
    const checkIsSubscribed = async () => {
        try {
            const res = await Axios.get(`v1/noti/subscription/${EVENT_NOTI_TOPIC_KEY}`);
            if (res.status < 400) {
                overrideIsSubscribed({ [EVENT_NOTI_TOPIC_KEY]: res.data.is_subscribed });
            }
        }
        catch (e) {
            captureException(e);
        }
    };
    useEffect(() => {
        checkIsSubscribed();
    }, []);
    const isAlimEnabled = notiTypeAndKeyToIsSubscribedAndPushOn[EVENT_NOTI_TOPIC_KEY];
    const subscribeEventNotification = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventNotificationSubscribe');
        toggleSubscription(EVENT_NOTI_TOPIC_KEY);
    };
    const handleKakaoShare = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokKakaoButtonClick', {
            isMember: !!user
        });
        if (!user || !bokInfo?.referral_code) {
            redirectToLogin();
            return;
        }
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventKakaoShare');
        const shareUrl = bokInfo?.referral_code ? `${SHARE_TARGET_URL}&referral=${bokInfo.referral_code}` : SHARE_TARGET_URL;
        try {
            Kakao.Share.sendDefault({
                objectType: 'feed',
                content: {
                    title: user?.nickname ? `${user.nickname}님이 당신을 5만 원어치 뷰티템 0원 이벤트에 초대했어요🫢` : '5만 원어치 뷰티템 0원 이벤트에 초대합니다🫢',
                    description: bokInfo?.referral_code ? `[초대코드 : ${bokInfo.referral_code}] 입력하고 헤메코랩이 쏘는 장바구니 이벤트 참여하세요` : '헤메코랩이 쏘는 장바구니 이벤트 참여하세요',
                    imageUrl: 'https://d1cnx04b8cgzcv.cloudfront.net/bok/bok_event_thumbnail.png',
                    link: {
                        // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
                        mobileWebUrl: shareUrl,
                        webUrl: shareUrl
                    }
                },
                buttons: [
                    {
                        title: '복바구니 참여하러 가기',
                        link: {
                            mobileWebUrl: shareUrl,
                            webUrl: shareUrl
                        }
                    },
                ]
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    const [isResultModalOpen, setIsResultModalOpen] = useState(false);
    const openResultModal = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventResultModalOpen');
        if (!user) {
            redirectToLogin();
            return;
        }
        setIsResultModalOpen(true);
    };
    const closeModal = () => {
        setIsResultModalOpen(false);
    };
    const handleShareClipboardClick = () => {
        console.log('handleClipboardClick');
        typeof mixpanel !== 'undefined' && mixpanel.track('BokCopyButtonClick', {
            isMember: !!user
        });
        if (!user) {
            redirectToLogin();
            return null;
        }
        return bokInfo?.referral_code;
    };
    const handleCopyReferralClipboardClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokReferralCopyButtonClick', {
            isMember: !!user
        });
        return referralCode;
    };
    return (<div>
            <KakaoLoader />
            {/*<div className={styles.menuContainer}>*/}
            {/*    <div className={classNames(styles.menu, styles.activeMenu)}>복바구니</div>*/}
            {/*    <div className={styles.menu}>하루특가</div>*/}
            {/*    <div className={styles.menu}>장바구니 인기템</div>*/}
            {/*</div>*/}
            {isResultModalOpen &&
            <BokEventResultModal close={closeModal} bokInfo={bokInfo}/>}
            <div className={styles.alimContainer}>
                <div style={{
            backgroundImage: `url(https://d1cnx04b8cgzcv.cloudfront.net/bok/cart.png)`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
        }} className={styles.cartIcon}/>
                <div className={styles.alimTitle}>원하는 뷰티템 0원</div>
                <div>
                    <div className={styles.alimDesc}>나만의 福바구니에 원하는 제품 담고 응모하면 참여완료!</div>
                    <div className={styles.alimDesc}>장바구니 이벤트 응모하고 친구에게 공유해보세요<br />내가 데려온 친구가 응모완료하는 순간 응모권이 하나 더!</div>
                    <div className={styles.alimDesc}>오늘 당첨되지 않았다고 실망하지 마세요!<br />응모권은 매일매일 계속 만들 수 있으니까요~</div>
                </div>
                <div className={classNames(styles.alimButton, isAlimEnabled ? styles.alimButtonEnabled : undefined)} onClick={subscribeEventNotification}>
                    {!isAlimEnabled ?
            <>매일 알림 받을래요<AlimIcon viewBox="0 0 24 24" className={styles.alimIcon}/></>
            :
                <>알림 신청 완료! 내일 만나요</>}
                </div>
                <div className={classNames(styles.checkButton)} onClick={openResultModal}>
                    <span>응모 결과 확인하기</span>
                    <ArrowRightIcon viewBox="0 0 16 16" className={styles.checkArrowRightIcon}/>
                </div>
            </div>
            {!!specialProduct &&
            <div className={styles.specialContainer}>
                    <div style={{
                    backgroundImage: `url(https://d1cnx04b8cgzcv.cloudfront.net/bok/heart.png)`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                }} className={styles.heartIcon}/>
                    <div className={styles.specialSubTitle}>오늘만 담을 수 있는 추천템이에요!</div>
                    <div className={styles.specialTitle}>복바구니 하루특가</div>
                    <div className={styles.specialDesc}>
                        복바구니 당첨이 되지 않아도<br />
                        이것만은 꼭 담아가세요!
                    </div>
                    <Link href={getProductRoute(specialProduct.id)}>
                        <div className={styles.specialProductCard}>
                            <div className={styles.specialProductCardImage}>
                                <Image unoptimized layout={'fill'} objectFit={'cover'} src={specialProduct.thumbnail_url}/>
                            </div>
                            <div className={styles.specialProductInfoContainer}>
                                <div>
                                    <div className={styles.specialBrandName}>{specialProduct.brand_name}</div>
                                    <div className={styles.specialProductName}>{specialProduct.name}</div>
                                </div>
                                <div>
                                    {specialProduct.discount_rate > 0 &&
                    <div className={styles.specialPrice}>{numberWithComma(specialProduct.price)}</div>}
                                    <div className={styles.specialPriceContainer}>
                                        {specialProduct.discount_rate > 0 &&
                    <div className={styles.specialDiscountRate}>{specialProduct.discount_rate}<span className={styles.specialPercentage}>%</span></div>}
                                        <div className={styles.specialDiscountPrice}>{numberWithComma(specialProduct.discounted_price)}</div>
                                    </div>
                                </div>
                                <ArrowRightIcon viewBox="0 0 16 16" className={styles.specialArrowRightIcon}/>
                            </div>
                        </div>
                    </Link>
                    <div className={styles.specialButton} onClick={() => {
                    if (specialProduct) {
                        setTargetProduct(specialProduct);
                        typeof mixpanel !== 'undefined' && mixpanel.track('BokSpecialProductPouchButtonClick', {
                            productId: specialProduct.id
                        });
                    }
                }}>
                        복바구니에 담기 +
                    </div>
                </div>}
            <div className={styles.chartContainer}>
                <div style={{
            backgroundImage: `url(https://d1cnx04b8cgzcv.cloudfront.net/bok/rank.png)`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
        }} className={styles.heartIcon}/>
                <div className={styles.chartSubTitle}>헤메코인들의 복바구니에 가장 많이 담긴 인기템이에요!</div>
                <div className={styles.chartTitle}>오늘의 복바구니 TOP3</div>
                {chartProducts.length === 0 ?
            <LoadingDot style={{ marginTop: 40 }}/>
            :
                <div className={styles.chartProductContainer}>
                            {chartProducts.map((e, idx) => {
                        e.rank = idx + 1;
                        return (<div className={styles.chartProductListCardContainer} key={e.id} onClick={() => {
                                typeof mixpanel !== 'undefined' && mixpanel.track('BokChartProductListCardClick', {
                                    productId: e.id
                                });
                            }}>
                                            <ProductListCard showRank={true} product={e} newRank/>
                                        </div>);
                    })}
                        </div>}
            </div>
            <img src={"https://d1cnx04b8cgzcv.cloudfront.net/bok/guide_v2.png"} style={{ width: '100%' }}/>
            <div className={styles.etcContainer}>
                <img src={"https://d1cnx04b8cgzcv.cloudfront.net/bok/etc_v2.png"} style={{ width: '100%' }}/>
                <div className={styles.participationInfoContainer}>
                    <div className={styles.participationInfoMyContainer}>
                        <div className={styles.participationCounter}>
                            {numberWithComma(user ? bokInfo?.today_my_count : 0)}
                        </div>
                        <div className={styles.participationDesc}>
                            오늘 내 응모수
                        </div>
                    </div>
                    <div className={styles.participationInfoTotalContainer}>
                        <div className={styles.participationCounter}>
                            {numberWithComma(bokInfo?.today_apply_count)}
                        </div>
                        <div className={styles.participationDesc}>
                            오늘 전체 응모수
                        </div>
                    </div>
                </div>
                <div className={styles.kakaoShareIcon} onClick={() => handleKakaoShare()}/>
                <div className={styles.copyCodeButton}>
                    <Clipboard option-text={handleShareClipboardClick} onSuccess={() => {
            toast.info('내 초대코드가 복사되었어요.');
        }}/>
                </div>
            </div>
            <div className={styles.tabContainer}>
                <div className={classNames(styles.tab, !currentCategory?.id ? styles.activeTab : undefined)} onClick={() => {
            if (tabRef.current)
                tabRef.current.scrollIntoView();
            setCurrentCategory({ id: null });
        }}>전체</div>
                {categories.map(c => {
            return (<div key={`${c.id}-category`} ref={tabRef} className={classNames(styles.tab, currentCategory?.id === c.id ? styles.activeTab : undefined)} onClick={() => {
                    if (tabRef.current)
                        tabRef.current.scrollIntoView();
                    setCurrentCategory(c);
                }}>{c.name}</div>);
        })}
            </div>
            {isLoading ?
            <LoadingDot style={{ marginTop: 200, marginBottom: 300 }}/>
            :
                <div className={styles.productListContainer}>
                        <div className={classNames(styles.productsSection)}>
                            <Row className={styles.row}>
                                {products.map((e, idx) => {
                        e.rank = idx + 1;
                        return (<Col key={e.id} xs={6} className={styles.col}>
                                                <div onClick={() => {
                                typeof mixpanel !== 'undefined' && mixpanel.track('BokProductListCardClick', {
                                    productId: e.id
                                });
                            }}>
                                                    <ProductListCard showRank={idx <= 9} newRank product={e}/>
                                                </div>
                                                <div onClick={() => onPouchClick(e)} className={styles.bokPouchButton}>복바구니 담기</div>
                                            </Col>);
                    })}
                            </Row>
                        </div>
                    </div>}
            <img src={'https://d1cnx04b8cgzcv.cloudfront.net/bok/warn.png'} style={{ width: '100%' }}/>
            <Modal isOpen={!!targetProduct} bottom={true} width={"100%"} close={() => {
            closeOptionSelector();
        }}>
                {!!targetProduct &&
            <div className={styles.selectorContainer}>
                        <OptionSelectionDropdownWithQuantitySelector maxCount={100} optionId={targetProduct.leaf_options[0].id} options={targetProduct.leaf_options} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} placeholder={'하이'} disallowAdditionalPrice={false} product={targetProduct} fixedCount={false} allowSoldOut={false} hidePrice={false} ignoreMaxCount={true}/>
                        <div className={styles.bokButton}>
                            <FullButton disabled={isPouchLoading || Object.keys(selectedOptions).length === 0} lightWhite={isPouchLoading || Object.keys(selectedOptions).length === 0} onClick={() => addToPouch(selectedOptions)} height={48} fontSize={16}>
                                {!isPouchLoading ?
                    '복바구니에 담기'
                    :
                        <LoadingDot />}
                            </FullButton>
                        </div>
                    </div>}
            </Modal>
            <div className={styles.bottomButtonsContainer}>
                <div className={styles.bottomButtonsPadding}>
                    {referralCode ?
            <BokEventReferralBeltBanner referral={referralCode} handleClipboardClick={handleCopyReferralClipboardClick}/> :
            <BokEventBeltBanner referral={bokInfo?.referral_code} handleShareClick={handleKakaoShare} handleClipboardClick={handleShareClipboardClick}/>}
                    {((bokInfo?.today_apply_ends_at ?? 0) < Date.now() / 1000) ?
            <div className={styles.bottomButtonsWrapper}>
                                <FullButton fontSize={16} height={48} onClick={() => {
                    typeof mixpanel !== 'undefined' && mixpanel.track('ViewBokEventResultClick', {
                        isMember: !!user
                    });
                    openResultModal();
                }}>
                                    응모결과 확인하기
                                </FullButton>
                            </div> :
            <div className={styles.bottomButtonsWrapper}>
                                <div className={styles.bottomLeftButton}>
                                    <FullButton fontSize={16} height={48} onClick={() => {
                    typeof mixpanel !== 'undefined' && mixpanel.track('ViewPouchList', {
                        isMember: !!user
                    });
                    if (!user) {
                        redirectToLogin();
                        return;
                    }
                    setIsPouchModalOpen(true);
                }} white>내 복바구니 보기</FullButton>
                                </div>
                                <div className={styles.bottomRightButton}>
                                    <FullButton onClick={() => {
                    onParticipateClick();
                }} disabled={participationDisabled} lightWhite={participationDisabled} fontSize={16} height={48}>
                                <span>
                                    {participationDisabled ?
                    (event?.participation_count === 0 ?
                        <>응모하기<span className={styles.bottomSubText}>(0번 가능)</span></>
                        :
                            '응모 완료')
                    :
                        <>응모하기<span className={styles.bottomSubText}>({event?.max_participation_count - event?.participation_count}번 가능)</span></>}
                                </span>
                                    </FullButton>
                                </div>
                            </div>}
                </div>
            </div>
            <BottomModal preventBackgroundClose={false} isOpen={isPouchModalOpen} close={() => { setIsPouchModalOpen(false); }}>
                <div className={styles.pouchModalContainer}>
                    <PouchModal close={() => { setIsPouchModalOpen(false); }} addToPouch={addToPouch} pouchItems={pouchItems} setPouchItems={setPouchItems}/>
                </div>
            </BottomModal>
        </div>);
};
export default Bok;

    async function __Next_Translate__getServerSideProps__1964211ef83__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/events/[eid]/Bok',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1964211ef83__ as getServerSideProps }
  